document.addEventListener("DOMContentLoaded", function() {
  setTimeout(() => {
    let reviewsHead = document.getElementById('reviews-head');
     if (reviewsHead && reviewsHead.length > 0) {
       let container = document.getElementById('reviews-head');
       let headButton = container.querySelector('.head-button');
       headButton.textContent = "";
       let newSpan = document.createElement('span');
       newSpan.textContent = "WRITE A REVIEW";
       headButton.appendChild(newSpan);
       // Add the 'slide' class to the button
       // headButton.classList.add('slide');
      let review_footer = document.getElementById('reviews-footer');
      let nextButtonText = review_footer.querySelector('.next-page');
      let prevButtonText = review_footer.querySelector('.pre-page');
      nextButtonText.textContent = "Next";
      nextButtonText.style.width = "auto";
      nextButtonText.classList.add('btn-nav');
      prevButtonText.textContent = "Previous";
      prevButtonText.style.width = "auto";
      prevButtonText.classList.add('btn-nav');
    }
   
    
    let no_reviews_container = document.getElementById('vstar-noreviews');
    if(no_reviews_container && no_reviews_container.length > 0 ){
          let write_review_button = no_reviews_container.querySelector('.noreviews-button');
          write_review_button.classList.add('review_button_style');
    }
    
  }, 1000);
});
